import {
  atLeastOneDigit,
  atLeastOneSpecialCharacter,
  atLeastOneUpperCaseCharacter,
} from '@shared/regexps';

export const validatePassword = (password: string) => {
  const hasAtLeastOneUpperCaseCharacter =
    atLeastOneUpperCaseCharacter.test(password);
  const hasAtLeastOneDigit = atLeastOneDigit.test(password);
  const hasAtLeastOneSpecialCharacter =
    atLeastOneSpecialCharacter.test(password);

  return (
    hasAtLeastOneUpperCaseCharacter &&
    hasAtLeastOneDigit &&
    hasAtLeastOneSpecialCharacter
  );
};
